// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  versonaId: __t.u64().primaryKey().name("versona_id"),
  worldId: __t.u64().name("world_id"),
  owner: __t.identity(),
  custom: __t.bool(),
  name: __t.string(),
  archetype: __t.string(),
  persona: __t.string(),
  context: __t.string(),
  greeting: __t.string(),
  deflect: __t.string(),
  topicsJson: __t.string().name("topics_json"),
  llm: __t.bool(),
  strict: __t.bool(),
  temperature: __t.f32(),
  maxWords: __t.u32().name("max_words"),
  wanderM: __t.f32().name("wander_m"),
  updatedAt: __t.timestamp().name("updated_at"),
});
